<template>
	<div class="body">
		<div class="box" style="user-select: none;">
			<div style="display: flex;align-items: center;">
				<div class="button-div" @click="old_value = ''">重置Conf</div>
				<div v-if="type == 1" class="info-msg">Areas 和 TransSrvIpaddr 还需要配置</div>
			</div>
			<div class="select">
				<div style="font-weight: 600;color: #888;">文件类型</div>
				<div class="select-div" :class="{selected: type == 1}" @click="type = 1">UST</div>
				<div class="select-div" :class="{selected: type == 2}" @click="type = 2">UTD</div>
				<div class="select-div" :class="{selected: type == 3}" @click="type = 3">AUTH</div>
				<div class="select-div" :class="{selected: type == 4}" @click="type = 4">MNG</div>
			</div>
			<input class="required" v-if="type != 4" type="text" name="id" v-model="id" placeholder="ID" />
			<input class="required" type="text" name="ip" v-model="ip" placeholder="IP" />
			<input v-if="type != 4" type="text" name="auth" v-model="auth" placeholder="AUTH" />
			<input type="text" name="web" v-model="web" placeholder="WEB后台" />
			<div class="checkbox" v-if="type == 4">
				<div @click="() => toggleOpen('ust')">
					<input name="open" value="ust" type="checkbox" v-model="open">
					UST
				</div>
				<div @click="() => toggleOpen('utd')">
					<input name="open" value="utd" type="checkbox" v-model="open">
					UTD
				</div>
				<div @click="() => toggleOpen('auth')">
					<input name="open" value="auth" type="checkbox" v-model="open">
					AUTH
				</div>
			</div>
			<!-- <select type="text" v-model="type" placeholder="文件类型">
				<option value="1">UST</option>
				<option value="2">UTD</option>
				<option value="3">AUTH</option>
				<option value="4">MNG</option>
			</select> -->

			<textarea name="old" v-model="old_value"></textarea>
		</div>
		<div class="box">
			<div class="textarea">{{new_value}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				ip: "",
				id: "",
				auth: "",
				web: "",
				type: 1,
				old_value: "",
				open: [],
				// new_value: ""
			}
		},
		watch: {
			// id(id){
			// 	console.log(id)
			// }
		},
		methods:{
			toggleOpen(name){
				if(this.open.includes(name)){
					this.open = this.open.filter(i => i != name)
				} else {
					this.open = [...this.open, name]
				}
			}
		},
		computed:{
			new_value(){
				var new_text = this.old_value;
				var sid = ""
				if(this.type == 1){
					if(this.id.length == 1){
						sid = "1200" + this.id
					} else if(this.id.length == 2){
						sid = "120" + this.id
					} else if(this.id.length == 3){
						sid = "12" + this.id
					} else {
						sid = this.id
					}
					new_text = new_text
						.replace(/ServerId=[\d]*/, "ServerId=" + sid) // 修改ID
						.replace(/ServerName=UST[\d]*/, "ServerName=UST" + this.id) // 修改服务器名(UST + ID )
						.replace(/ServerPublicIpaddr=[\d.]*/, "ServerPublicIpaddr=" + this.ip) // 修改IP
						.replace(/ServerPrivateIpAddr=[\d.]*/, "ServerPrivateIpAddr=" + this.ip) // 修改IP
					if(this.auth){ // 修改AUTH
						new_text = new_text
							.replace(/DispSrvIpaddr=[\d.]*/, "DispSrvIpaddr=" + this.auth)
							.replace(/AuthSrvIpaddr=[\d.]*/, "AuthSrvIpaddr=" + this.auth)
							.replace(/AuthSrvGroupIpaddr\[0\]=[\d.]*/, "AuthSrvGroupIpaddr[0]=" + this.auth)
					}
					if(this.web){ // 修改WEB地址
						new_text = new_text
							.replace(/UmeyeSrvIpaddr=[\d.]*/, "UmeyeSrvIpaddr=" + this.web)
							.replace(/OpenIpaddr=[\d.]*/, "OpenIpaddr=" + this.web)
							.replace(/UAIpaddr=[\d.]*/, "UAIpaddr=" + this.web)
					}
				}
				if(this.type == 2){
					if(this.id.length == 1){
						sid = "1400" + this.id
					} else if(this.id.length == 2){
						sid = "140" + this.id
					} else if(this.id.length == 3){
						sid = "14" + this.id
					} else {
						sid = this.id
					}
					new_text = new_text
						.replace(/ServerId=[\d]*/, "ServerId=" + sid) // 修改ID
						.replace(/ServerPublicIpaddr=[\d.]*/, "ServerPublicIpaddr=" + this.ip) // 修改IP
						.replace(/MonthTotalNetRate=[\d.]*/, "MonthTotalNetRate=0") // 清零流量
					if(this.auth){ // 修改AUTH
						new_text = new_text.replace(/DispSrvIpaddr=[\d.]*/, "DispSrvIpaddr=" + this.auth)
					}
					if(this.web){ // 修改WEB地址
						new_text = new_text.replace(/UmeyeSrvIpaddr=[\d.]*/, "UmeyeSrvIpaddr=" + this.web)
					}
				}
				if(this.type == 3){
					if(this.id.length == 1){
						sid = "200" + this.id
					} else if(this.id.length == 2){
						sid = "20" + this.id
					} else if(this.id.length == 3){
						sid = "2" + this.id
					} else {
						sid = this.id
					}
					new_text = new_text
						.replace(/AuthServerId=[\d]*/, "AuthServerId=" + sid) // 修改ID
					if(this.auth){ // 修改AUTH
						new_text = new_text
							.replace(/UstSrvIpaddr=[\d.]*/, "UstSrvIpaddr=" + this.auth)
							.replace(/DemoStreamIpaddr=[\d.]*/, "DemoStreamIpaddr=" + this.auth)
							.replace(/AuthPublicAddr=[\d.]*/, "AuthPublicAddr=" + this.auth)
							.replace(/AuthPrivateAddr=[\d.]*/, "AuthPrivateAddr=" + this.auth)
							.replace(/ThumbSrvIpaddr\[0\]=[\d.]*/, "ThumbSrvIpaddr[0]=" + this.auth)
					}
					if(this.web){ // 修改WEB地址
						new_text = new_text
							.replace(/UmeyeSrvIpaddr=[\d.]*/, "UmeyeSrvIpaddr=" + this.web)
					}
				}
				if(this.type == 4){
					new_text = new_text
						.replace(/PublicSrvIpaddr=[\d.]*/, "PublicSrvIpaddr=" + this.ip) // 修改IP
					if(this.web){ // 修改WEB地址
						new_text = new_text
							.replace(/UmeyeSrvIpaddr=[\d.]*/, "UmeyeSrvIpaddr=" + this.web)
					}
					new_text = new_text
						.replace(/SrvEnable\[(\d)\]=\d\nSrvName\[(\d)\]=NpcSmpUstServer/, `SrvEnable[$1]=${this.open.includes('ust') ?1 :0}\nSrvName[$2]=NpcSmpUstServer`)
						.replace(/SrvEnable\[(\d)\]=\d\nSrvName\[(\d)\]=NpcSmpUtdServer/, `SrvEnable[$1]=${this.open.includes('utd') ?1 :0}\nSrvName[$2]=NpcSmpUtdServer`)
						.replace(/SrvEnable\[(\d)\]=\d\nSrvName\[(\d)\]=NpcMonAuthServer/, `SrvEnable[$1]=${this.open.includes('auth') ?1 :0}\nSrvName[$2]=NpcMonAuthServer`)
				}
				return new_text
			},
		},
	}
</script>
<style scoped>
	.button-div{
		display: inline-block;
		border: 2px solid #888;
		border-radius: 8px;
		margin-bottom: 8px;
		padding: 2px 12px;
		cursor: pointer;
	}
	.body{
		padding: 50px 0;
		display: flex;
		background-color: rgb(250, 250, 250);
		height: 100vh;
		box-sizing: border-box;
	}
	.box{
		width: 50%;
		padding: 0 2.5%;
		box-sizing: border-box;
	}
	input.required::placeholder{
		color: red;
	}
	textarea, .textarea{
		width: 100%;
		border: 2px solid #888;
		border-radius: 8px;
		padding: 10px;
	}
	input, select{
		width: 100%;
		border: 2px solid #888;
		border-radius: 8px;
		margin-bottom: 8px;
		padding: 2px 10px;
	}
	.checkbox, .checkbox>div{
		display: flex;
		height: 32px;
		align-items: center;
	}
	.checkbox{
		margin-bottom: 8px;
	}
	.checkbox>div{
		cursor: pointer;
	}
	.checkbox input{
		margin-bottom:  0;
		margin-right: 5px;
		margin-left: 12px;
	}
	textarea{
		min-height: 400px;
	}
	.textarea{
		min-height: 300px;
		max-height: 80vh;
		overflow: scroll;
		white-space: pre-wrap;
	}
	.info-msg{
		color: red;
		margin-bottom: 8px;
		margin-left: 20px;
		font-weight: 600;
	}
	.select{
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}
	.select-div{
		border: 2px solid #888;
		border-radius: 8px;
		box-sizing: border-box;
		padding: 2px 10px;
		margin: 0 0 0 12px;
		flex: 1;
		text-align: center;
		cursor: pointer;
	}
	.select-div.selected{
		background-color: #888;
		color: #FFF;
		font-weight: 600;
	}
</style>